import { isSubscriptionOverlayVisible } from '../../../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIDFAQSceneController {
    hide() {
        this.faqSceneContainerDiv.classList.add('hidden');
        this.faqSceneContainerDiv.classList.remove('above-subscription-overlay');
    }
    show() {
        this.faqSceneContainerDiv.classList.remove('hidden');
        this.faqSceneContainerDiv.classList.toggle('above-subscription-overlay', isSubscriptionOverlayVisible());
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.faqSceneContainerDiv = document.getElementById('scene_discord_faq_container');
    }
}
